export default "__VITE_PUBLIC_ASSET__650f6294__"